import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_URL,
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('../views/Dashboard/Dashboard.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../views/Dashboard/Dashboard.vue'),
    },
    {
      path: '/advertisements',
      name: 'advertisements',
      component: () => import('../views/Advertisements/Advertisements.vue'),
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('../views/Business/Business.vue'),
    },
    {
      path: '/business/:id',
      name: 'businessDetail',
      component: () => import('../views/Business/BusinessDetail'),
    },
    {
      path: '/business/:businessId/ad/:id',
      name: 'advertisementDetail',
      component:() => import('../views/Advertisement/AdvertisementDetail')
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: () => import('../views/404'),
    },
  ],
});

//to solve route duplication error
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

export default router;
